import { TabMenu } from 'primereact/tabmenu';
export default TabMenu;